import React, {useEffect, useState} from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Loop } from '@material-ui/icons';
import { Grid, TextField, Button } from '@material-ui/core'
import { loadDepartures, changeDepartureDate, changeDestination, changeFlightNumber, changeOrigin, changePassenger, changeRloc, changeTailNumber, changeStatus } from "../../../store/dcs";
import _ from 'lodash';
import styles from "../styles";
import Filters from './Filters';
import { fetchNewTexts, setShowFilter } from '../../../store/dcs';
import {formatFlightDate} from '../util/formatFlightDate';
import moment from 'moment';

export default function Headers(props) {
  const dispatch = useDispatch();
  const { isMobile, theme,filters } = props;
  const classes = styles(theme, isMobile);
  const [showFilters, setShowFilters] = useState(false);
  const depDate = useSelector(state => state.entities.dcs.departureDate);
  const newTexts = useSelector(state => state.entities.dcs.newTexts);

  const [date, setDate] = useState(moment(depDate));

  useEffect(() => {}, [newTexts])

  const changeDepartureDateRq = (event) => {
    const selectedDate = moment(event.target.value, 'YYYY-MM-DD');
    setDate(selectedDate);
    dispatch(changeDepartureDate(selectedDate.format('YYYY-MM-DD')));
    filters.date.set({ target: { value:selectedDate.format('YYYY-MM-DD')} });
    dispatch(loadDepartures(formatFlightDate(selectedDate.format('YYYY-MM-DD'))));
  }

  const clearFilters = () => {
    dispatch(changeDestination('None'))
    dispatch(changeFlightNumber('None'))
    dispatch(changeOrigin('None'))
    dispatch(changeTailNumber('None'))
    dispatch(changeRloc(''))
    dispatch(changePassenger(''))
    dispatch(changeStatus('Active'))
  }

  const refreshPage = () => {
    dispatch(loadDepartures(formatFlightDate(depDate)))
  }

  const handleTextFetch = () => {
    dispatch(fetchNewTexts())
 }

 const handleFilterDisplay = () => {
   setShowFilters(!showFilters);
   dispatch(setShowFilter(!showFilters));
 }

 const handleNextClick = () => {
  const nextDate = moment(date).add(1, 'day'); // increase date by 1 day using moment
  setDate(nextDate);
  filters.date.set({ target: { value: nextDate.format('YYYY-MM-DD') } }); // update filters.date.val with formatted string
  dispatch(loadDepartures(formatFlightDate(nextDate.format('YYYY-MM-DD'))));
  dispatch(changeDepartureDate(nextDate.format('YYYY-MM-DD'))); // update depDate state
};

const handlePreClick = () => {
  const preDate = moment(date).subtract(1, 'day'); // decrease date by 1 day using moment
  setDate(preDate);
  filters.date.set({ target: { value: preDate.format('YYYY-MM-DD') } }); // update filters.date.val with formatted string
  dispatch(loadDepartures(formatFlightDate(preDate.format('YYYY-MM-DD'))));
  dispatch(changeDepartureDate(preDate.format('YYYY-MM-DD'))); // update depDate state
};
  // TODO // add current filter values to choices if selected choice isn't there (i.e. 12/01/21 select ANU origin then go to 11/30/21 and it's gone)

  return (
    <Grid container className='dcs' style={{marginBottom: '10px', marginTop: '10px', marginLeft: '20px', }}>
      <Grid className="flightPageFilters leftheader-Mob dcs">
        <Grid container className="dateNavigateBlock">
        <TextField
        id="depDate"
        label="Departure Date"
        type="date"
        value={date.format('YYYY-MM-DD')}
        defaultValue={date.format('YYYY-MM-DD')}
        className={classes.indexTextField}
        InputLabelProps={{ shrink: true }}
        onChange={changeDepartureDateRq}
      />
          <div className="navigateBtns">
            <Button className="nextPrev-btn" onClick={handlePreClick}>{"<<"}</Button>
            <Button className="nextPrev-btn" onClick={handleNextClick}>{">>"}</Button>
          </div>
        
        </Grid>
        <Grid container class="dcs-button-block" alignContent="center" justifyContent="flex-end" item xs={12} sm={12} lg={12}>
          <Button variant="contained" size="small" style={{height: 'fit-content'}} onClick={() => {clearFilters()}}>Clear Filters</Button>
          <Button variant="contained" size="small" style={{height: 'fit-content'}} onClick={() => {refreshPage()}}>Refresh</Button>
          <Button variant="contained" size="small" style={{height: 'fit-content'}} onClick={handleTextFetch}><Loop /> Texts</Button>
          <Button variant="contained" size="small" style={{height: 'fit-content'}} onClick={handleFilterDisplay}>{showFilters ? "Hide Filters" : "Show Filters"}</Button>
        </Grid>
        {/* <Grid container item xs={12} sm={6} lg={8} style={{ marginTop: window.innerWidth < 600 ? '8px' : '0px' }}>
          <Grid container alignContent="center" justifyContent="center" item xs={4} sm={4} lg={2}>
            <Button variant="contained" size="small" style={{height: 'fit-content'}} onClick={() => {refreshPage()}}>Refresh</Button>
          </Grid>
          <Grid container alignContent="center" justifyContent="center" item xs={4} sm={4} lg={2}>
            <Button variant="contained" size="small" style={{height: 'fit-content'}} onClick={handleTextFetch}><Loop /> Texts</Button>
          </Grid>
          <Grid container alignContent="center" justifyContent="center" item xs={4} sm={4} lg={2}>
            <Button variant="contained" size="small" style={{height: 'fit-content'}} onClick={handleFilterDisplay}>{showFilters ? "Hide Filters" : "Show Filters"}</Button>
          </Grid>
        </Grid> */}
      </Grid>
      {showFilters ? <Filters theme={theme} isMobile={isMobile} /> : ''}
    </Grid>
  );
}